/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!******************************************!*\
  !*** ./src/assets/js/sale-collection.js ***!
  \******************************************/
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var SaleCollectionProductsSection = /*#__PURE__*/function () {
  function SaleCollectionProductsSection() {
    _classCallCheck(this, SaleCollectionProductsSection);

    this.selectors = {
      section: ".sale-collection-section",
      swiper: ".sale-collection-products__slider"
    };
    this.modificators = {
      active: "active"
    };
    this.activeSlider = null;
  }

  _createClass(SaleCollectionProductsSection, [{
    key: "initSlider",
    value: function initSlider(slider, section) {
      if (this.activeSlider) {
        this.activeSlider.destroy();
      }

      var sliderOptions = JSON.parse(slider.getAttribute('data-swiper-settings'));
      var nextButton = section.querySelector('.swiper-button-next-featured');
      var prevButton = section.querySelector('.swiper-button-prev-featured');

      var options = _objectSpread({
        slidesPerView: 3,
        spaceBetween: 30,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton
        },
        breakpoints: {
          0: {
            slidesPerView: 1.4,
            spaceBetween: 12,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20
          },
          768: {
            slidesPerView: 2.5,
            spaceBetween: 16,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20
          },
          1024: {
            slidesPerView: 3.5,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 40
          },
          1280: {
            slidesPerView: 4.5,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 50
          }
        }
      }, sliderOptions);

      this.activeSlider = new Swiper(slider, options);
    }
  }, {
    key: "toggleSaleSwiper",
    value: function toggleSaleSwiper() {
      document.querySelector('.switcher-wrapper').style.display = "flex";
      var swiper = document.getElementById("saleSwiper");

      if (document.querySelector('.switcher-wrapper #saleSwitch').checked) {
        document.querySelector('.featured_collection_section').style.display = "block";
      } else {
        document.querySelector('.featured_collection_section').style.display = "none";
      }
    }
  }, {
    key: "handleSections",
    value: function handleSections() {
      var _this = this;

      var sections = document.querySelectorAll(this.selectors.section);
      sections.forEach(function (section) {
        var slider = section.querySelector(_this.selectors.swiper);

        if (slider) {
          _this.initSlider(slider, section);

          _this.toggleSaleSwiper();

          document.querySelector('.switcher-wrapper #saleSwitch').addEventListener('change', _this.toggleSaleSwiper);
        }
      });
    }
  }]);

  return SaleCollectionProductsSection;
}();

document.addEventListener("DOMContentLoaded", function () {
  window.SaleCollectionProductsSection = [];
  window.SaleCollectionProductsSection.push(new SaleCollectionProductsSection().handleSections());
});
/******/ })()
;